<template>
  <div class="pa-4">
    <v-card color="surface-light" flat rounded="lg">
      <v-card-text class="px-4 pt-3 pb-0">
        <v-textarea
          ref="promptInput"
          v-model="message"
          auto-grow
          autofocus
          bg-color="transparent"
          density="compact"
          :disabled
          hide-details
          max-rows="10"
          no-resize
          persistent-placeholder
          :placeholder="t('deepa_chat.prompt_placeholder')"
          rows="1"
          variant="plain"
          @keydown.enter.exact.prevent="sendRequest"
        />
      </v-card-text>

      <v-card-actions class="px-2 pt-0 pb-2">
        <v-spacer />
        <v-btn
          v-if="loading"
          :aria-label="t('deepa_chat.stop')"
          color="primary"
          density="comfortable"
          icon="fas fa-stop"
          variant="text"
          @click="onClickStop"
        />
        <v-btn
          v-else
          :aria-label="t('buttons.send')"
          color="primary"
          density="comfortable"
          :disabled="disabled || !hasContent"
          icon="far fa-arrow-up"
          variant="text"
          @click="sendRequest"
        />
      </v-card-actions>
    </v-card>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  loading: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits<{
  (e: 'send', message: string): void
  (e: 'stop'): void
}>()

const { t } = useI18n()

const message = ref('')
const lastMessage = ref('')
const promptInput = useTemplateRef('promptInput')

const hasContent = computed(() => message.value.trim() !== '')

function sendRequest() {
  if (props.loading || props.disabled || !hasContent.value) return
  emit('send', message.value.trim())
  lastMessage.value = message.value
  message.value = ''
}

function onClickStop() {
  if (!message.value.trim()) {
    message.value = lastMessage.value
  }
  promptInput.value?.focus()
  emit('stop')
}

const isPromptVisible = useElementVisibility(() => promptInput.value?.$el)

watch(isPromptVisible, (visible) => {
  if (visible) {
    promptInput.value?.focus()
  }
})
</script>
